export default __webpack_public_path__ + "static/media/logo-jira.261ab8a4.svg";